import React from "react";
import { Box } from "@mui/material";
import Text from "../text/Text";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function MiniAppHeading({ title, handleAction }) {
  return (
    <Box
      className="mini-app-heading"
      padding="12px 15px"
      sx={{ cursor: "pointer" }}
      onClick={handleAction}
    >
      <Text font="bold" className="default-text" size={20}>
        {title}
      </Text>
      <ArrowForwardIosIcon className="arrow" />
    </Box>
  );
}

export default MiniAppHeading;
